import React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Toolbar from '@mui/material/Toolbar';
import Logo from '../DTP/HeaderNavigation/Logo';
import { HCPNavFields } from './HCPHeaderNavigation.types';
import IconButton from '@mui/material/IconButton';
import HamburgerIcon from '../shared/HamburgerIcon/HamburgerIcon';
import CloseIcon from '../shared/CloseIcon/CloseIcon';
import HCPMobileDrawConent from './HCPMobileDrawConent';
import { ImageField } from '@sitecore-jss/sitecore-jss-react';

const drawerWidth = '256px';
const fallbackImg: ImageField = { value: { src: '' } };
const HCPMobileNav: React.FC<HCPNavFields> = (props) => {
  const [isDrawerOpen, setIsDrawerOpen] = React.useState(false);
  if (!props.navigationLinks) return <></>;
  const handleDrawerToggle = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };
  return (
    <Box sx={{ marginInline: '2rem' }} id="hcp-mobile-header-navigation">
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Box>
          <Logo
            id={'hcp-mobile-logo'}
            imageField={props.headerLogo || fallbackImg}
            ariaLabel={props?.headerLogoAriaLabel?.value as string}
          />
        </Box>
        <IconButton
          color="inherit"
          aria-label={
            isDrawerOpen
              ? (props?.closeButtonAriaLabel?.value as string)
              : (props?.openMenuAriaLabel?.value as string)
          }
          edge="start"
          onClick={handleDrawerToggle}
        >
          {isDrawerOpen ? <CloseIcon /> : <HamburgerIcon />}
        </IconButton>
      </Box>
      <Drawer
        variant="temporary"
        anchor="right"
        open={isDrawerOpen}
        onClose={handleDrawerToggle}
        elevation={0}
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box' },
        }}
      >
        <Toolbar />
        <HCPMobileDrawConent
          navigationLinks={props.navigationLinks}
          openProfileModal={props?.openProfileModal}
          isAuthenticated={props?.isAuthenticated}
          handleDrawerToggle={handleDrawerToggle}
        />
      </Drawer>
    </Box>
  );
};
export default HCPMobileNav;
